<template>
  <div>
    <b-button id="back-button" 
              size="sm" variant="primary"
              class="app-ctrl back-button"
              @click="navigateToMarkets()">
      <font-awesome-icon :icon="['far', 'arrow-alt-left' ]" /> Back
    </b-button>
      
    <div data-bs-theme="light" style="position: relative;">
      <div style="width: 100%;">
        <AgGridVue  ref="grid"
                    :class="getTheme"
                    :columnDefs="dynamicColumnDefs"
                    :defaultColDef="defaultColumnDefinitions"
                    :excelStyles="excelStyles"
                    :gridOptions="gridOptions"
                    :groupHideOpenParents="false"
                    :rowHeight="60"
                    :localeText="localeText"
                    :rowData="localRowData"
                    :sideBar="sideBar"
                    style="width: 100%;"
                    :tooltipShowDelay="tooltipShowDelay"
                    />
      </div>
    </div>
  </div>
</template>

<script>
  import "ag-grid-community/dist/styles/ag-grid.css";
  import "ag-grid-community/dist/styles/ag-theme-alpine.css";
  import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
  import "ag-grid-community/dist/styles/ag-theme-balham.css";
  import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";
  import "ag-grid-community/dist/styles/ag-theme-material.css";
  import { AgGridVue } from "ag-grid-vue";
  import 'ag-grid-enterprise';

  import CxTableColumns from '@/mixins/jlr/CxTableColumns';
  import JlrNumberCellRenderer from '@/components/CX/Grid/JlrNumberCellRenderer';
  import LastReportCellRenderer from '@/components/CX/Grid/LastReportCellRenderer';
  import RetailerCellRenderer from '@/components/CX/Grid/RetailerCellRenderer';
  import RetailerValueCellRenderer from '@/components/CX/Grid/RetailerValueCellRenderer';

export default {
  mixins: [ CxTableColumns ],

  components: {
    AgGridVue, JlrNumberCellRenderer,
    LastReportCellRenderer, RetailerCellRenderer, RetailerValueCellRenderer // Card, CxDashboardHeader
  },

  props: {
    countryId:          { type: String, default: () => '' },
    defaultLogo:        { type: String, default: () => undefined },
    retailerData:       { type: Object, default: () => {} },
   
  },

  data() {
    return {
      isMounted: false,

      marginOverview: null,
      marketCxScores: [],
      marketExplorationScores: [],
      marketNonExplorationScores: [],
      
      gridOptions: { 
        animateRows: true,
        autoGroupColumnDef: {
          headerName: this.$t('Webportal.CX.Retailer'),
          field: "QuestionText",
          resizable: true,
          Width: 500,
          autoHeight: true,
          cellRendererParams: {
            suppressCount: true,
          },
          cellClassRules: {
            'market-question-cell': params => { 
              return !(!params.value || params.value.length === 2 || !params.data);
            }
          }
        },
        context: {
          getLocation: (key)  => {
            return this.retailerData.Locations.find(x => x.ClientLocationId === key);
          }, 
          getRetailerText: (params) => {
            const regex = /___(\d+)$/;
            let nodekey = params.node.key;
            let parentkey = params.node.parent.key;
            let val = params.value;
            if (parentkey === null) {
              let number = nodekey && nodekey.match(regex) ? nodekey.match(regex)[1] : undefined;
              let retailer = this.retailerData.ClusterGroup.find(x => x.ClientLocationId === parseInt(number));
              if (!retailer) return { text: '' };
              let wave = retailer?.SurveyWave.find(x => x.Name === params.colDef.field);
              return { text: wave ? `${wave.Result}%` : '' };
            }

            let num = parentkey && parentkey.match(regex) ? parentkey.match(regex)[1] : undefined;
            let cluster = this.retailerData.Cluster.find(x => x.ClientLocationId === parseInt(num) && x.Code === params.node.key);
            if (!cluster) {
              if (params.data && params.data[`${params.column.colId}n`] === 1) {
                return { 
                  text: (parseInt(params.value) === 100) ? this.$t('Webportal.Yes') : this.$t('Webportal.No'),
                  style: parseInt(params.value) === 100 ? undefined : 'color: red;'
                };
              }
              return { text: params.value ? `${params.value}%` : undefined };
            }
            let wave = cluster.SurveyWave.find(x => x.Name === params.colDef.field);
            return { text: wave && wave.Result ? `${wave.Result}%` : undefined };
          },
          getDefaultLogo: ()  => {
            return this.defaultLogo;
          }, 
          hasChildren: (key) => {
            return this.retailerData.ClusterGroup.find(x => x.CountryId === key);
          },
          onClickRetailer: (retailerId)  => {
            if (this.alternativeDisplay) {
              let backup = JSON.parse(JSON.stringify(this.gridColumnApi.getColumnState()));
              this.$store.commit('ColumnBackup', backup);
            }
            this.$emit("drilldownToDashboard", retailerId);
          },
          getTranslation: (retailerKey, cluster) => {
            const regex = /___(\d+)$/;
            let number = retailerKey.match(regex) ? parseInt(retailerKey.match(regex)[1]) : undefined;
            const item = this.retailerData.Cluster.find(x => x.ClientLocationId === number && x.Code === cluster);
            return (!item) ? cluster : item.Name;
          },
          onClickDownload: (options)  => {
            this.$emit("downloadReport", options);
          }
        },
        domLayout: 'autoHeight',
        groupDefaultExpanded: 0,
        // suppressAggFuncInHeader: true,
        // groupDisplayType: 'custom',
        onColumnVisible: (event) => {
          event.api.sizeColumnsToFit();
        },
        onGridReady: (event) => {
          event.api.sizeColumnsToFit();
          this.gridApi = event.api;
          this.gridColumnApi = event.columnApi;
        },
        getContextMenuItems: function(params) {
          return null;
        },
        // defaultExcelExportParams: this.getExcelSettings(),
        // getContextMenuItems: this.getContextMenuItems
      },

      defaultColumnDefinitions: { 
        flex: 1,
        minWidth: 60,
        sortable: true,
        filter: true,
        enableRowGroup: false // custom row grouping
      },
    };
  },

  watch: {
    retailerData: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.refreshRetailerRowData(newVal);
        }
      }
    },
    alternativeDisplay: {
      handler(newVal, oldVal) {
        if (oldVal === true) {
          let backup = JSON.parse(JSON.stringify(this.gridColumnApi.getColumnState()));
          this.$store.commit('ColumnBackup', backup);
        }
        this.refreshRetailerRowData('switch');
        this.$emit("updated:alternativeDisplay", newVal);
      }
    }
  },

  mounted() {
    // this.localStaticColumnDefinitions = this.initRetailerStaticColumnDefinitions();
    this.isMounted = true;
    this.canHaveAccomplished = true;
  },

  methods: {
    getContextMenuItems(params) {
      return [
        'copy',
        'copyWithHeaders',
        'separator',
        {
          // custom item
          name: 'Export',
          action: () => {
            // Erste zwei Spalten entfallen, "Detail Link" und "Image" sind im Export nicht erwünscht
            // Hier werden aktuell sichtbare Columns selektiert
            var columns = this.gridColumnApi.getColumns();
            columns.splice(0, 2);
            this.gridApi.exportDataAsExcel({columnKeys: columns});
          },
          icon: '<i class="far fa-file-download"></i>'
        }
      ]
    },

    refreshRetailerRowData(values) {
      const data = values === 'switch' 
        ? this.retailerData 
        : values;

      if (!data.waves) 
        return;

      let local = [];
      if (this.alternativeDisplay) {
        this.localStaticColumnDefinitions =
          this.initRetailerStaticColumnDefinitionsAlternative();

        let dynamicColumns = this.initRetailerColumnsAlternative(data);
        let tree = this.flattenTree(dynamicColumns)
        tree.forEach(x => x.hide = true);
        this.restoreSettings(tree, this.$store.state.ui);
        tree.forEach(x => {
          if (x.forceVisible) x.hide = false;
        });
        this.localDynamicColumnDefinitions = dynamicColumns;

        local = this.computeRetailersAlternative(data);
      } else {
        this.localStaticColumnDefinitions = 
          this.initRetailerStaticColumnDefinitions();
        
        this.localDynamicColumnDefinitions = 
          this.initRetailerColumns(data.waves, data.Cluster, data.ClusterGroup);
        
        local = this.computeRetailers(data);
      }
      try {
        local.sort((a, b) => {
          let result = a.Name.localeCompare(b.Name,  'de', { sensitivity: 'base' });
          if (result !== 0) return result;
          result = a.Code.localeCompare(b.Code,  'de', { sensitivity: 'base' });
          if (result !== 0) return result;
          return a.QuestionText.localeCompare(b.QuestionText,  'de', { sensitivity: 'base' });
        });
      } catch (error) {
        // initial sort can fail, if retailers have absolutely no data, this is not important
        // and maybe the whole sort will be removed in the near future
      }
      this.localRowData = local;
    },

    navigateToMarkets() {
      if (this.alternativeDisplay) {
        let backup = JSON.parse(JSON.stringify(this.gridColumnApi.getColumnState()));
        this.$store.commit('ColumnBackup', backup);
      }
      this.$emit("drilldownToMarkets");
    }
  }
}

</script>

<style>
.back-button {
    position: absolute;
    margin: 0.6rem 1rem;
    font-size: 16px;
    cursor: pointer;
    z-index: 1000; /* Ensure it appears above the grid */
}
</style>